// extracted by mini-css-extract-plugin
module.exports = {"Form":"Search_Form__2sK_A","Text":"Search_Text__3frkQ","Error":"Search_Error__1dTIh"};